module.exports = __webpack_public_path__ + "img/Microsoft Graph API (Email)-5.jpg";